export const getHost = () => (window._env_ && window._env_.REACT_APP_HOST) || process.env.REACT_APP_HOST;
